import { useTheme } from "@mui/material";
import { useMemo } from "react";
import type { PortfolioItemColor } from "web_myplann/Portfolio/Types/PortfolioAddItemTypes";

type PortfolioItemColorValue = { icon: string; surface: string };

const PALETTE_FAMILY: Record<PortfolioItemColor, string> = {
	pink: "pink",
	orange: "orange",
	blue: "blue",
	sky: "blue",
	violet: "purple",
	green: "green",
	amber: "amber",
	teal: "teal",
	indigo: "indigo",
	yellow: "yellow",
	red: "red",
	neutral: "grey",
};

export const usePortfolioItemColor = (
	color: PortfolioItemColor,
): PortfolioItemColorValue => {
	const { palette } = useTheme();

	return useMemo(() => {
		const scale = palette[
			PALETTE_FAMILY[color] as keyof typeof palette
		] as Record<number, string>;
		return { icon: scale[600], surface: scale[100] };
	}, [color, palette]);
};
